import { render, staticRenderFns } from "./Reporte-ventas.vue?vue&type=template&id=0748eb96&"
import script from "./Reporte-ventas.vue?vue&type=script&lang=js&"
export * from "./Reporte-ventas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports